import i18n from 'modules/core/lib/i18n'

import { DueDatesFields } from 'modules/processes/hooks/useProcesses'

// Direction selection options
const defaultOffsetDirection = () => {
  return [
    { value: 'after', label: i18n.t('processes.process_settings.tasks.form.due_dates.after') },
    { value: 'before', label: i18n.t('processes.process_settings.tasks.form.due_dates.before') },
  ]
}

export const offsetDirection = (selectedReference: DueDatesFields | null | undefined) => {
  if (selectedReference === DueDatesFields.ProcessStartDate)
    return [...defaultOffsetDirection()].slice(0, 1)

  return defaultOffsetDirection()
}
